"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_PLATFORM_VERSION = void 0;
exports.APP_PLATFORM_VERSION = '0.148.1';
//# sourceMappingURL=index.js.map